
// => Styling
import styles from './Collapsible.module.css';

// => Icons
import { 
    IoChevronDown,
    IoChevronUp,
} from "react-icons/io5";

// => React
import { useState, useRef, useEffect } from 'react';


// ============
// Component
// ============
const Collapsible = ({
    open = false,
    onOpenUpdate = () => {},
    title = "Collapsible Title (no title set!)",
    children,
}) => {

    const [isOpen, setIsOpen] = useState(open)
    const [height, setHeight] = useState(0)

    const handleFilterOpening = () => {
        setIsOpen((prev) => !prev)
    }

    const ref = useRef(null)

    useEffect(() => {
        if (isOpen) {
            setHeight(ref.current?.getBoundingClientRect().height)
            onOpenUpdate()
        } else {
            setHeight(0)
        }
    }, [isOpen])

    useEffect(() => {
        function onResize() {
            setHeight(ref.current?.getBoundingClientRect().height)
        }
        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    })


    // RENDER
    // ---------
    return(
        <div className={styles.container}>

            {/* Header */}
            <div className={styles.header} onClick={handleFilterOpening}>
                <span className={styles.title}>{title}</span>
                <span className={styles.headerIcon}>
                    {isOpen ? (
                        <IoChevronDown />
                    ) : (
                        <IoChevronUp />
                    )}
                </span>
            </div>

            <div className={styles.content} style={{height}}>
                {isOpen && 
                    <div className={styles.children} ref={ref}>{children}</div>
                }
            </div>

        </div>
    );
}


export default Collapsible